exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pie-chart-card[data-v-44a9acc6] {\n    flex-grow: 2;\n    margin-right: 0 !important;\n}\n.filter-buttons a[data-v-44a9acc6] {\n    padding: 0 10px;\n}\n", ""]);

// exports
